<!--note: this componnet is currently separate from the "NotificationModal" because it has a special behavior, and refreshs after being closed-->
<template>
  <section class="shadow-box modal_wrapper">
    <div class="popup-message">
      <div class="main-part">
        <div class="close desktop" @click="closePopup">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g transform="translate(0)">
              <g transform="translate(0 0)">
                <rect
                  width="17.423"
                  height="2.376"
                  transform="translate(0 12.32) rotate(-45)"
                  class=""
                ></rect>
              </g>
              <rect
                width="17.423"
                height="2.376"
                transform="translate(1.68 0) rotate(45)"
                class=""
              ></rect>
            </g>
          </svg>
        </div>
        <div class="general-body">
          <!--          <h3 class="title">Congratulations {{ userFirstName }},<br>You are a Member!</h3>-->
          <h3 class="title">{{ t("Congratulations_title") }}</h3>
          <p class="message">{{ t("Congratulations_body") }}</p>
          <a :href="userLoginLink" class="btn semiBold to-platform desktop">{{
            t("Congratulations_CTA")
          }}</a>
          <div></div>
        </div>
      </div>
      <div class="mobile-buttons">
        <button class="btn semiBold close-btn" @click="closePopup">
          {{ t("close") }}
        </button>
        <a class="btn semiBold to-platform mobile" :href="userLoginLink">{{
          t("Congratulations_CTA")
        }}</a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "MessageModal",
  computed: {
    ...mapState(["userFirstName", "accountId"]),
    ...mapGetters(["t", "userLoginLink"])
  },
  methods: {
    closePopup: function() {
      location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal_wrapper {
  h3 {
    font-size: 24px;
  }

  &.shadow-box {
    /*position: absolute;*/
    position: fixed;
    width: 100vw;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    height: 100%;
    width: 100%;
    z-index: 10000000000000000;
  }

  .popup-message {
    position: fixed;
    top: 18%;
    left: 50%;
    width: 90%;
    transform: translate(-50%, 18%);
    max-width: 500px;
    height: auto;
    z-index: 9;
    text-align: center;
    padding: 32px 40px;
    border-radius: 5px;
    background-color: #fff;
    color: #424242;
  }

  .close {
    position: absolute;
    top: 15px;
    right: 15px;
    float: none;
    font-size: 13px;
    font-weight: 400;
    line-height: 1;
    text-shadow: none;
    color: #000;
    opacity: 0.5;
    text-align: center;
    :hover {
      cursor: pointer;
    }
  }

  .general-body {
    /*padding: 20px 0 30px;*/
    padding-bottom: 0;
  }

  .general-body .title {
    font-size: 24px;
    margin-bottom: 22px;
    margin-right: auto;
    margin-left: auto;
    color: #424242;
  }

  .general-body .message {
    font-size: 16px;
    color: #333333;
    margin-bottom: 30px;
  }

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 3px;
    //padding: 7px;
    outline: none;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    background: #1c79be;
    margin: 0 auto;
    /*width: 100%;*/
    width: 330px;
    height: 40px;
    font-weight: 500;
  }

  .btn:hover {
    color: #fff; /*required to ignore general css at stage*/
  }

  form {
    max-width: 330px;
    width: 100%;
    margin: 0 auto;
  }

  .server_error_msg {
    display: flex;
    position: relative;
    padding: 12px 0;
  }

  .input-wrapper {
    position: relative;
    min-height: 70px;
  }

  .input_wrap {
    position: relative;
  }

  input {
    font-size: 16px;
    width: 100%;
    height: 40px;
    border-radius: 3px;
    padding: 0 15px;
    border: 1px solid #d5d3d3;
    color: #424242;
    outline: none;
    background: #fff;
  }

  .floating_labels {
    color: #7a7c7c;
    position: absolute;
    z-index: -1;
    opacity: 0;
    top: -2px;
    left: 12px;
    transition: all 200ms;
    text-align: left;
    background: #fff;
    font-size: 12px;
    padding: 0 4px;
  }

  .mobile-buttons {
    display: none;
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }
    .popup-message {
      margin: 0;
      padding: 0;
      max-width: calc(100% - 3rem);

      .main-part {
        padding: 2rem 1.125rem;
        border-radius: 0px;
        margin: 0 auto;

        .general-body {
          .title {
            margin-bottom: 1rem;
          }

          .message {
            margin-bottom: 0;
          }
        }
      }
      .mobile-buttons {
        display: flex;
        width: 100%;
        .btn {
          border-radius: 0;
          padding: 0;
          width: 50%;
        }

        .close-btn {
          background-color: #d5d3d3;
          color: #7a7c7c;
          border-radius: 0;
          font-weight: 500;
        }
        .to-platform {
          border-radius: 0;
          font-weight: 500;
        }
      }
    }

    .fr .mobile-buttons {
      a {
        font-size: 0.875rem;
      }
    }
  }
}
</style>
